import React from 'react';

export default function PageHeader({
  title,
  subtitle,
  action,
}: {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-baseline justify-between gap-4 mb-8 flex-wrap">
      <div>
        <h1 className="text-2xl sm:text-[32px] font-extrabold tracking-tight text-[#241c14] dark:text-lc-text leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1.5 text-sm text-[#7a6b5d] dark:text-lc-faint">{subtitle}</p>
        )}
      </div>
      {action && <div className="flex items-center gap-3 shrink-0">{action}</div>}
    </div>
  );
}
